import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { TableV2 } from '@anytag/shared-atoms';
import { useInfluencerPackagePermissions } from '@anytag/auth';
import { useInfluencerPackagesTable } from '../hooks';
import { InfluencersListWidget } from '../InfluencersListWidget';
import { useInfluencerPackagesContext } from '../InfluencerPackagesContext';

export const InfluencerPackagesList = () => {
  const { t } = useTranslation();
  const { hideAddPackageBtn } = useInfluencerPackagePermissions();
  const { loading, listRecords } = useInfluencerPackagesContext();
  const { columns } = useInfluencerPackagesTable();

  return (
    <TableV2
      loading={loading}
      data={listRecords}
      rowHeight="64px"
      columns={columns}
      className={cn(
        "[&_[data-slot='table-cell']:first-of-type]:px-0!",
        "[&_[data-slot='table-head']:first-of-type]:px-0!",
        "[&_[data-slot='table-cell']:nth-of-type(2)]:pl-4",
        "[&_[data-slot='table-head']:nth-of-type(2)]:pl-4"
      )}
      customExpandedRow={(row) => <InfluencersListWidget packageAccount={row.original} />}
      empty={{ linkProps: !hideAddPackageBtn ? { to: '/package/add', label: t('Add package') } : undefined }}
      hasBorder={false}
      noTopBorderRadius
    />
  );
};
